import React from 'react';
import classNames from 'classnames';

import ssPropTypes from '../../../modules/ssPropTypes';

import SSErrorBoundary from '../../SSErrorBoundary';
import NotificationsBadge from './NotificationsBadge';
import NotificationFeed from './NotificationFeed';
import ModalHost from '../../ui/ModalHost';
import ModalContext from '../../ui/ModalContext';

import './DropdownFeed.scss';

const DROPDOWN_BTN_CLASS = 'notification-dropdown-btn';

/**
 * Outputs a button which, when pressed, displays the notification feed in a dropdown.
 */
export default class DropdownFeed extends React.PureComponent {
  static propTypes = {
    /** The provider to show the notifications for. */
    providerId: ssPropTypes.numberLike.isRequired,
  };

  state = {
    isOpen: false,
    notifications: [],
  };

  unmounted = true;
  clickHandlersSetup = false;
  containerRef = React.createRef();

  componentDidMount() {
    this.unmounted = false;
    this.setupClickHandlers();
  }

  componentDidUpdate() {
    this.setupClickHandlers();
  }

  componentWillUnmount() {
    this.unmounted = true;
    document.removeEventListener('click', this.globalClickHandler);
    this.clickHandlersSetup = false;
  }

  /**
   * Manually put a global click handler on the document
   */
  setupClickHandlers() {
    const dropdownEl = this.containerRef.current;
    if (dropdownEl) {
      document.addEventListener('click', this.globalClickHandler, false);
      this.clickHandlersSetup = true;
    }
  }

  /**
   * Close the dropdown when clicking anywhere outside of the menu and not on the button
   */
  globalClickHandler = evt => {
    if (this.state.isOpen && !$(evt.target).is(`.${DROPDOWN_BTN_CLASS}`)) {
      this.closeDropdown();
    }
  };

  /**
   * Notifications have been loaded by the feed component.
   * @param {Array} notifications
   */
  notificationsLoaded = notifications => {
    this.setState({ notifications });
  };

  /**
   * Close the dropdown menu.
   */
  closeDropdown = () => {
    this.setState({ isOpen: false });
  };

  /**
   * Toggle the open state of the dropdown.
   */
  toggleDropdown = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { providerId } = this.props;
    const { isOpen, notifications } = this.state;

    return (
      <ModalHost>
        <section
          className={classNames(
            'notification-feed-dropdown',
            { 'is-open': isOpen },
          )}
          ref={this.containerRef}
        >
          <button
            type="button"
            className={classNames(
              DROPDOWN_BTN_CLASS,
            )}
            onClick={this.toggleDropdown}
            aria-label="Notifications"
            data-testid="notificationFeedDropdownToggle"
          >
            <SSErrorBoundary>
              <NotificationsBadge
                className="bounce-in"
                providerId={providerId}
                notifications={notifications}
              />
            </SSErrorBoundary>
          </button>
          <div className="notification-dropdown-list">
            <ModalContext.Consumer>
              {modalContext => (
                <NotificationFeed
                  providerId={this.props.providerId}
                  viewing={isOpen}
                  onNotificationsLoaded={this.notificationsLoaded}
                  modalContext={modalContext}
                />
              )}
            </ModalContext.Consumer>

          </div>
        </section>
      </ModalHost>
    );
  }
}
